import LoginView from "@/pages/authentication/views/LoginView";

export default function LoginDesktopView() {
    return <LoginView mode="desktop" />;
}
